import { getDateISOStringToday } from '@/Common/util/date'
import { ref, watch } from 'vue'

export function useBoostimate(payItem, defaultQuantity, defaultDate) {
  const quantity = ref(null)
  const date = ref(getDateISOStringToday())

  if (defaultQuantity) {
    watch(
      defaultQuantity,
      () => {
        // Update the boostimate quantity when the passed quantity changes
        // Unset the quantity if the item is lump sum
        if (payItem.value?.is_lump_sum && defaultQuantity.value == 1) {
          quantity.value = null
        } else {
          if (defaultQuantity.value) quantity.value = defaultQuantity.value
        }
      },
      { immediate: true }
    )
  }

  if (defaultDate) {
    watch(
      defaultDate,
      () => {
        if (defaultDate.value) date.value = defaultDate.value
      },
      { immediate: true }
    )
  }

  return { quantity, date }
}

export const boostimateTextClasses =
  'bg-gradient-to-r from-amber-600 to-indigo-600 bg-clip-text text-transparent dark:from-amber-400 dark:to-indigo-400'
